// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2LcCT","select":"Header_select__pvOEu","clinic":"Header_clinic__3Wm0Y"};